import client, { ensureCsrf, initialiseCsrf } from './client';

// Auth
export const adminLogin = async (email, password, remember = false) => {
  await initialiseCsrf();
  const { data } = await client.post('/admin/login', { email, password, remember });
  return data;
};
export const adminLogout = async () => {
  await ensureCsrf();
  return (await client.post('/admin/logout')).data;
};
export const adminMe = async () => (await client.get('/admin/me')).data;
export const adminDashboard = async () => (await client.get('/admin/dashboard')).data;

// Marketplace oversight
export const listAdminProperties = async (params = {}) => (await client.get('/admin/properties', { params })).data;
export const getAdminProperty = async (id) => (await client.get(`/admin/properties/${id}`)).data;
export const listAdminBookings = async (params = {}) => (await client.get('/admin/bookings', { params })).data;
export const getAdminBooking = async (id) => (await client.get(`/admin/bookings/${id}`)).data;
export const listAdminCustomers = async (params = {}) => (await client.get('/admin/customers', { params })).data;
export const getAdminCustomer = async (id) => (await client.get(`/admin/customers/${id}`)).data;
export const listAdminMessages = async (params = {}) => (await client.get('/admin/messages', { params })).data;
export const getAdminBookingMessages = async (id) => (await client.get(`/admin/bookings/${id}/messages`)).data;

// Users (admin users and hosts)
export const listUsers = async (params = {}) => (await client.get('/admin/users', { params })).data;
export const getUser = async (id) => (await client.get(`/admin/users/${id}`)).data;
export const createUser = async (payload) => {
  await ensureCsrf();
  return (await client.post('/admin/users', payload)).data;
};
export const updateUser = async (id, payload) => {
  await ensureCsrf();
  return (await client.patch(`/admin/users/${id}`, payload)).data;
};
export const deleteUser = async (id) => {
  await ensureCsrf();
  return (await client.delete(`/admin/users/${id}`)).data;
};

// Master data — features
export const listFeatures = async () => (await client.get('/admin/features')).data;
export const createFeature = async (payload) => { await ensureCsrf(); return (await client.post('/admin/features', payload)).data; };
export const updateFeature = async (id, payload) => { await ensureCsrf(); return (await client.put(`/admin/features/${id}`, payload)).data; };
export const deleteFeature = async (id) => { await ensureCsrf(); return (await client.delete(`/admin/features/${id}`)).data; };

// Rules
export const listRules = async () => (await client.get('/admin/rules')).data;
export const createRule = async (payload) => { await ensureCsrf(); return (await client.post('/admin/rules', payload)).data; };
export const updateRule = async (id, payload) => { await ensureCsrf(); return (await client.put(`/admin/rules/${id}`, payload)).data; };
export const deleteRule = async (id) => { await ensureCsrf(); return (await client.delete(`/admin/rules/${id}`)).data; };

// Policy Types
export const listPolicyTypes = async () => (await client.get('/admin/policy-types')).data;
export const createPolicyType = async (payload) => { await ensureCsrf(); return (await client.post('/admin/policy-types', payload)).data; };
export const updatePolicyType = async (id, payload) => { await ensureCsrf(); return (await client.put(`/admin/policy-types/${id}`, payload)).data; };
export const deletePolicyType = async (id) => { await ensureCsrf(); return (await client.delete(`/admin/policy-types/${id}`)).data; };

// Policy Options
export const listPolicyOptions = async () => (await client.get('/admin/policy-options')).data;
export const createPolicyOption = async (payload) => { await ensureCsrf(); return (await client.post('/admin/policy-options', payload)).data; };
export const updatePolicyOption = async (id, payload) => { await ensureCsrf(); return (await client.put(`/admin/policy-options/${id}`, payload)).data; };
export const deletePolicyOption = async (id) => { await ensureCsrf(); return (await client.delete(`/admin/policy-options/${id}`)).data; };

// Moderation
export const listTestimonials = async (params = {}) => (await client.get('/admin/testimonials', { params })).data;
export const updateTestimonial = async (id, payload) => { await ensureCsrf(); return (await client.patch(`/admin/testimonials/${id}`, payload)).data; };

export const listAdminPropertyReviews = async (params = {}) => (await client.get('/admin/property-reviews', { params })).data;
export const updatePropertyReview = async (id, payload) => { await ensureCsrf(); return (await client.patch(`/admin/property-reviews/${id}`, payload)).data; };

// Audit logs
export const listAuditLogs = async (params = {}) => (await client.get('/admin/audit-logs', { params })).data;
